export class ProductInfoAttributes {
  productName: string;
  publisherName: string;
  iscanType: number;
  swType: number;
  licenseType: number;
  swGroupCode: number = 1;

  constructor(obj?: any) {
    const productInfoAttr = obj || {};
    Object.assign(this, productInfoAttr);
  }
}
